import { render } from "./AboutPageJourneySectionCMS.vue?vue&type=template&id=0530a527"
import script from "../js/about-page-journey-section-cms.js?vue&type=script&lang=js"
export * from "../js/about-page-journey-section-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__